import { datadogRum } from '@datadog/browser-rum'

/**
 * Initializes Datadog Real User Monitoring (RUM) for the RSA frontend.
 * Only runs in the browser when Application ID and Client Token are configured.
 */

export const initDatadogRum = () => {
    if (typeof window === 'undefined') return

    //   const appId = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
    //   const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
    //   const env = process.env.NEXT_PUBLIC_ENV;

    //   if (!appId || !clientToken) {
    //     console.log("Datadog RUM not initialized");
    //     return;
    //   }
    console.log('Datadog RUM initialized')
    datadogRum.init({
        applicationId: '8e7cdf0c-a3a0-4545-b7c7-894690a468d2',
        clientToken: 'pub64b7d8c4e852a525290ef739c58c5796',
        site: 'datadoghq.com',
        service: 'container-app',
        env: 'UAT',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask-user-input',
    })

    datadogRum.startSessionReplayRecording()
}
